import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { UserCheck, Users } from "lucide-react";

const TYPES = ["All", "BOP", "Consume", "Service", "Capital", "Jobwork"];
const APPROVAL = ["Open", "Approved", "Reject", "All"];
const AI_ACTIONS = ["All", "APPROVE", "REVIEW", "HOLD"];

export default function FilterBar({ filters, setFilters, approvers = [], showApproverFilter = false, supplierSuggestions = [] }) {
  const set = (k, v) => setFilters((f) => ({ ...f, [k]: v }));
  const myTurn = !filters.approver || filters.approver === "__me__";

  return (
    <div className="bg-white border border-slate-200 rounded-sm p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4">
        <div className="lg:col-span-2">
          <Label className="text-xs uppercase tracking-wider text-slate-500">Purchase Type</Label>
          <div className="mt-2 flex flex-wrap gap-1">
            {TYPES.map((t) => (
              <button
                key={t}
                data-testid={`tab-${t.toLowerCase()}`}
                onClick={() => set("purc_type", t)}
                className={`px-3 py-1.5 text-xs font-semibold rounded-md transition-colors ${
                  filters.purc_type === t
                    ? "bg-cyan-700 text-white"
                    : "bg-slate-100 text-slate-700 hover:bg-cyan-100"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div>
          <Label htmlFor="date" className="text-xs uppercase tracking-wider text-slate-500">Date</Label>
          <Input
            id="date"
            type="date"
            data-testid="filter-date"
            value={filters.vdate || ""}
            onChange={(e) => set("vdate", e.target.value)}
            className="mt-2"
          />
        </div>

        <div>
          <Label htmlFor="sup" className="text-xs uppercase tracking-wider text-slate-500">Supplier</Label>
          <datalist id="dashboard-supplier-suggest">
            {supplierSuggestions.map((s) => <option key={s} value={s} />)}
          </datalist>
          <Input
            id="sup"
            data-testid="filter-supplier"
            placeholder="Start typing supplier…"
            value={filters.supplier || ""}
            onChange={(e) => set("supplier", e.target.value)}
            list="dashboard-supplier-suggest"
            className="mt-2"
          />
        </div>

        <div>
          <Label className="text-xs uppercase tracking-wider text-slate-500">AI Recommendation</Label>
          <Select value={filters.ai_action} onValueChange={(v) => set("ai_action", v)}>
            <SelectTrigger data-testid="filter-ai-action" className="mt-2">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {AI_ACTIONS.map((a) => (
                <SelectItem key={a} value={a}>{a}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label className="text-xs uppercase tracking-wider text-slate-500">Approval</Label>
          <Select value={filters.approval} onValueChange={(v) => set("approval", v)}>
            <SelectTrigger data-testid="filter-approval" className="mt-2">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {APPROVAL.map((a) => (
                <SelectItem key={a} value={a}>{a}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {showApproverFilter && (
          <div className="lg:col-span-6">
            <Label className="text-xs uppercase tracking-wider text-slate-500">Scope</Label>
            <div className="mt-2 inline-flex rounded-sm border border-slate-300 overflow-hidden" data-testid="scope-toggle">
              <button
                onClick={() => set("approver", "__me__")}
                data-testid="scope-me"
                className={`px-3 py-1.5 text-xs font-semibold inline-flex items-center gap-1.5 transition-colors ${
                  myTurn ? "bg-cyan-700 text-white" : "bg-white text-slate-700 hover:bg-cyan-50"
                }`}
              >
                <UserCheck size={13} /> My Turn
              </button>
              <button
                onClick={() => set("approver", "all")}
                data-testid="scope-all"
                className={`px-3 py-1.5 text-xs font-semibold inline-flex items-center gap-1.5 transition-colors border-l border-slate-300 ${
                  !myTurn ? "bg-cyan-700 text-white" : "bg-white text-slate-700 hover:bg-cyan-50"
                }`}
              >
                <Users size={13} /> All PRs
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
